import { Pipe, PipeTransform } from "@angular/core";
import {
  ComponentViewModel,
  MediaCategoryTypeNameEnum,
  MediaTypeNameEnum,
  SectionViewModel,
} from "src/domain/client";
import { MediaPipe } from "./media.pipe";

@Pipe({
  name: "faqSearch",
  pure: true,
})
export class FaqSearchPipe implements PipeTransform {
  constructor(private mediaPipe: MediaPipe) {}

  transform(
    items: SectionViewModel[] | ComponentViewModel[],
    query: string,
  ): SectionViewModel[] | ComponentViewModel[] {
    if (!query) {
      return items;
    }

    if (!items || !items.length) {
      return [];
    }

    if (items[0] instanceof SectionViewModel) {
      return (items as SectionViewModel[]).filter((s) =>
        s.components?.some(
          (c) =>
            this.mediaPipe
              .transform(
                c.media,
                MediaCategoryTypeNameEnum.Title,
                MediaTypeNameEnum.Text,
              )
              .toLocaleLowerCase()
              .includes(query) ||
            this.mediaPipe
              .transform(
                c.media,
                MediaCategoryTypeNameEnum.Body,
                MediaTypeNameEnum.HTML,
              )
              .toLocaleLowerCase()
              .includes(query),
        ),
      );
    }

    if (items[0] instanceof ComponentViewModel) {
      return (items as ComponentViewModel[]).filter(
        (c) =>
          this.mediaPipe
            .transform(
              c.media,
              MediaCategoryTypeNameEnum.Title,
              MediaTypeNameEnum.Text,
            )
            .toLocaleLowerCase()
            .includes(query) ||
          this.mediaPipe
            .transform(
              c.media,
              MediaCategoryTypeNameEnum.Body,
              MediaTypeNameEnum.HTML,
            )
            .toLocaleLowerCase()
            .includes(query),
      );
    }

    return items;
  }
}
